module.exports = __webpack_public_path__ + "static/aw-facebook-d30618efcc71a33bc90d620e2f6771c0.svg";